"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const styled_components_1 = require("styled-components");
const ScreenSizes_1 = require("components/styled/ScreenSizes");
exports.Row = styled_components_1.default.div `
  display: flex;
  flex-wrap: wrap;
`;
exports.Column = styled_components_1.default.div `
  position: relative;

  ${props => props.widthPhone
    ? 'flex-basis:' + (100 / 2) * props.widthPhone + '%'
    : 'flex-basis: 100%'};
  ${props => props.widthPhone
    ? 'width:' + (100 / 2) * props.widthPhone + '%'
    : 'width: 100%'};

  ${ScreenSizes_1.TABLET_PORTRAIT} {
    padding-left: ${props => props.offsetTablet ? (100 / 8) * props.offsetTablet + '%' : '0px'};
    ${props => props.widthTablet
    ? 'flex-basis:' + (100 / 8) * props.widthTablet + '%'
    : 'flex-basis: 100%'};
    ${props => props.widthTablet
    ? 'width:' + (100 / 8) * props.widthTablet + '%'
    : 'width: 100%'};
  }

  ${ScreenSizes_1.TABLET_LANDSCAPE} {
    padding-left: ${props => props.offset ? (100 / 12) * props.offset + '%' : '0px'};
    ${props => props.width ? 'flex-basis:' + (100 / 12) * props.width + '%' : 'flex: 1'};
    ${props => props.width ? 'width:' + (100 / 12) * props.width + '%' : 'flex: 1'};
  }
`;



// WEBPACK FOOTER //
// ./src/components/styled/Grid.ts